import {Check, Film} from '@nlabs/gothamjs/icons';

import type {ReactElement} from 'react';

const takes = [
  {label: '01 / The pause', selected: false, src: new URL('../../assets/approval-entrance-take-01.png', import.meta.url).href},
  {label: '02 / Recognition', selected: true, src: new URL('../../assets/approval-entrance-take-02.png', import.meta.url).href}
];

export const TakeApprovalVisual = (): ReactElement => (
  <>
    <div className="mb-4 flex items-center justify-between text-[9px] tracking-[.14em] text-white/55"><span className="inline-flex items-center gap-2"><Film size={13} />THE ENTRANCE</span><span>2 TAKES</span></div>
    <div className="grid grid-cols-2 items-start gap-3">{takes.map(({label, selected, src}) => (
      <div className={`min-w-0 overflow-hidden rounded-xl border ${selected ? 'border-violet-300/80 bg-violet-400/15 shadow-lg shadow-violet-950/30' : 'border-white/15 bg-white/3'}`} key={label}>
        <div className="relative">
          <img alt="" className="h-32 w-full object-cover object-[50%_22%]" loading="lazy" src={src} />
          {selected && <span className="absolute right-1.5 bottom-1.5 inline-flex items-center gap-1 rounded-full bg-violet-200 px-2 py-1 text-[8px] font-semibold text-violet-950"><Check size={10} />Selected</span>}
        </div>
        <p className={`px-2 py-2.5 text-[9px] ${selected ? 'text-violet-100' : 'text-white/60'}`}>{label}</p>
      </div>
    ))}</div>
    <p className="mt-4 text-[10px] text-white/55">Same scene. A different feeling.</p>
  </>
);
